import React from 'react';

const MobileTestPage = () => {
  return (
    <div style={{
      padding: '40px',
      backgroundColor: '#ff6b6b',
      color: 'white',
      fontSize: '24px',
      fontWeight: 'bold',
      minHeight: '100vh',
      textAlign: 'center'
    }}>
      <h1>🎉 MOBILE TEST PAGE WORKS! 🎉</h1>
      <p>If you see this, the mobile routing is working!</p>
      <p>Time: {new Date().toLocaleTimeString()}</p>
      <div style={{ marginTop: '40px', fontSize: '18px' }}>
        <p>User Agent: {navigator.userAgent}</p>
      </div>
    </div>
  );
};

export default MobileTestPage;
